import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'conversation/phoneNumber/{id}';

const conversationsQueryKey = (phoneNumberId: string) => [BASE_QUERY_KEY, phoneNumberId];

export const useConversationsInfiniteQuery = ({
	enabled = true,
	phoneNumberId,
	pageSize = 25,
	unreadOnly = false,
	spamOnly = false,
	refetchOnWindowFocus,
	meta,
}: {
	enabled?: boolean;
	phoneNumberId: string;
	pageSize?: number;
	unreadOnly?: boolean;
	spamOnly?: boolean;
	refetchOnWindowFocus?: boolean;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IConversation>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageToken: pageParam, pageSize, unreadOnly, spamOnly },
					urlPath: `conversation/phoneNumber/${phoneNumberId}`,
				}),
				'GET'
			);
		},
		queryKey: [...conversationsQueryKey(phoneNumberId), { unreadOnly, spamOnly }, pageSize],
		refetchOnWindowFocus,
		initialPageParam: '',
		meta,
	});
};

export function invalidateConversations(phoneNumberId: string) {
	reactQueryClient.invalidateQueries({ queryKey: conversationsQueryKey(phoneNumberId) });
}
